import React, { Component } from 'react';
import './AccountHeader.css';

class AccountHeader extends Component {
  render() {
    return (
      <div className="AccountHeader">
        <div className="background">
          <div className="contents">
            <span className="desc">계정 삭제 안내</span>
            <span className="title">LEMONCAKE</span>
          </div>
        </div>
      </div>
    );
  }
}

export default AccountHeader;